<div>
  <div class="document-uploader">
    <input style="display: none"
      type="file"
      title="{{'Upload' | translate}}"
      [id]="'documentUploader_' + id"
      [multiple]="!cropBeforeLoad"
      (change)="handleInputChange($event)">
      @if (!hideUploadButton) {
        <label [for]="'documentUploader_' + id" class="file-input-label"
          [style.display]="'flex'">
          <span>{{'main.upload' | translate}}</span> <mat-icon>file_download</mat-icon>
        </label>
      }

      @if (newFiles && newFiles.length) {
        <div class="message-box">
          {{'main.newFile' | translate}}
        </div>
      }

      @for (file of newFiles; track file; let i = $index) {
        <div >
          <div class="file-data">
            @if (!picturePreview) {
              @switch (file.name.split('.')[file.name.split('.').length - 1]) {
                @case ('jpg') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('jpeg') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('png') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('gif') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('svg') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('doc') {
                  <img src="assets/images/icons/doc.svg" style="width: 35px">
                }
                @case ('docx') {
                  <img src="assets/images/icons/docx.svg" style="width: 35px">
                }
                @case ('pdf') {
                  <img src="assets/images/icons/pdf.svg" style="width: 35px">
                }
                @case ('txt') {
                  <img src="assets/images/icons/txt.svg" style="width: 35px">
                }
                @case ('xlsx') {
                  <img src="assets/images/icons/xls.svg" style="width: 35px">
                }
                @case ('xls') {
                  <img src="assets/images/icons/xls.svg" style="width: 35px">
                }
                @default {
                  <img src="assets/images/icons/file.svg" style="width: 35px">
                }
              }
            }
            @if (picturePreview) {
              @switch (file.type) {
                @case ('jpg') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('image/jpg') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('jpeg') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('image/jpeg') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('png') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('image/png') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('gif') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('image/gif') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('svg') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('image/svg') {
                  <img [src]="file.imgSrc" class="image-preview">
                }
                @case ('doc') {
                  <img src="assets/images/icons/doc.svg" style="width: 35px">
                }
                @case ('docx') {
                  <img src="assets/images/icons/docx.svg" style="width: 35px">
                }
                @case ('pdf') {
                  <img src="assets/images/icons/pdf.svg" style="width: 35px">
                }
                @case ('txt') {
                  <img src="assets/images/icons/txt.svg" style="width: 35px">
                }
                @case ('xls') {
                  <img src="assets/images/icons/xls.svg" style="width: 35px">
                }
                @default {
                  <img src="assets/images/icons/file.svg" style="width: 35px">
                }
              }
            }
            <span class="file-name">{{file.name}}</span>
            <mat-icon class="remove-icon" (click)="removeFile(file)">delete_outline</mat-icon>
          </div>
        </div>
      }

      @if (uploadedFiles && uploadedFiles.length) {
        <div class="message-box">
          {{'main.uplodedFile' | translate}}
        </div>
      }

      @for (file of uploadedFiles; track file) {
        <div>
          <div class="file-data">
            @if (!picturePreview) {
              @switch (file.name.split('.')[file.name.split('.').length - 1]) {
                @case ('jpg') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('jpeg') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('png') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('gif') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('svg') {
                  <img src="assets/images/icons/img.svg" style="width: 35px">
                }
                @case ('doc') {
                  <img src="assets/images/icons/doc.svg" style="width: 35px">
                }
                @case ('docx') {
                  <img src="assets/images/icons/docx.svg" style="width: 35px">
                }
                @case ('pdf') {
                  <img src="assets/images/icons/pdf.svg" style="width: 35px">
                }
                @case ('txt') {
                  <img src="assets/images/icons/txt.svg" style="width: 35px">
                }
                @case ('xls') {
                  <img src="assets/images/icons/xls.svg" style="width: 35px">
                }
                @default {
                  <img src="assets/images/icons/file.svg" style="width: 35px">
                }
              }
            }
            @if (picturePreview) {
              @switch (file.name.split('.')[file.name.split('.').length - 1]) {
                @case ('jpg') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('image/jpg') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('jpeg') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('image/jpeg') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('png') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('image/png') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('gif') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('image/gif') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('svg') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('image/svg') {
                  <img [src]="getFile(file.url)" class="image-preview">
                }
                @case ('doc') {
                  <img src="assets/images/icons/doc.svg" style="width: 35px">
                }
                @case ('docx') {
                  <img src="assets/images/icons/docx.svg" style="width: 35px">
                }
                @case ('pdf') {
                  <img src="assets/images/icons/pdf.svg" style="width: 35px">
                }
                @case ('txt') {
                  <img src="assets/images/icons/txt.svg" style="width: 35px">
                }
                @case ('xls') {
                  <img src="assets/images/icons/xls.svg" style="width: 35px">
                }
                @default {
                  <img src="assets/images/icons/file.svg" style="width: 35px">
                }
              }
            }
            <span class="file-name">{{file.name}}</span>
            @if (!hideUploadButton) {
              <mat-icon class="remove-icon" (click)="removeFileFromUpload(file)">delete_outline</mat-icon>
            }
            <a [href]="getFile(file.url)" target="_blank" rel="noopener noreferrer" ><mat-icon class="remove-icon">cloud_download</mat-icon></a>
          </div>
        </div>
      }
    </div>
  </div>

